/**
 * Current school-year ID (`isCurrent`) for filter prefill.
 */

import { useQuery } from '@tanstack/react-query';
import { getSchoolYears } from '@/services/school-years.service';

/**
 * Fetches the current school year (isCurrent = true) and returns its ID.
 * Used to pre-populate school-year filters with the current year on load.
 * Returns `undefined` while loading or if no current year is configured.
 */
export function useCurrentSchoolYearId(): string | undefined {
  const { data } = useQuery({
    queryKey: ['school-years', 'current', 'default-filter'],
    queryFn: () => getSchoolYears({ isCurrent: true, pageSize: 1 }),
  });
  return data?.data?.find((y) => y.isCurrent)?.id ?? data?.data?.[0]?.id;
}
